import React from 'react';
import './SearchNav.css';
import WelcomeName from './WelcomeName';
function SearchNav() {
    return (
        <>
        <div class="searchnav-container">
            <div class="searchnav-wrap">
                <div class="searchnav-row">
                    <div class="searchnav-box" style={{textAlign:'left',marginTop:'5px'}}>
                        <img src="images/Acc_Logo_Black_Purple_RGB.png" class="acc-logo" alt="logo" />
                        <p class="desktop-tag">Learning and Knowledge Management <br /> <span>Delivery</span>  </p>
                        <p class="mobile-tag">LKM</p>
                    </div>
                </div>
                <div class="searchnav-row">
                    <div class="searchnav-box" style={{textAlign:'right',marginTop:'5px'}}>
                    <WelcomeName />
                        <img src="images/Avatar.png" class="user-img" alt="user-image" />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default SearchNav
